export default "__VITE_ASSET__DUcUl8G6__"